import { render, staticRenderFns } from "./applyForwallet.vue?vue&type=template&id=515c9d57"
import script from "./applyForwallet.vue?vue&type=script&lang=js"
export * from "./applyForwallet.vue?vue&type=script&lang=js"
import style0 from "./applyForwallet.vue?vue&type=style&index=0&id=515c9d57&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports